import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import Institute from "../Layouts/InstituteForm";
import { showToast } from "src/utils/showToaster";
import { InstituteFormValues } from "src/models/Institute.model";
import { useAddInstituteMutation } from "src/services/InstituteService";

type Props = {
  onClose: () => void;
};

const AddInstituteWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const [addInstitute] = useAddInstituteMutation()

  const initialValues: InstituteFormValues = {
    instituteName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    instituteName: string().required("Please enter institute name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: InstituteFormValues,
    { setSubmitting, resetForm }: FormikHelpers<InstituteFormValues>
  ) => {
    const payload = {
      instituteName: values.instituteName,
    };
    addInstitute(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Institute formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddInstituteWrapper;
